/**
 * Accordion for product FAQs section - open/close FAQ items
 */
(function () {
  const bindFaqsRoot = (faqRoot) => {
    const accordions = faqRoot.querySelectorAll('.product-accordion');
    accordions.forEach((accordion) => {
      accordion.addEventListener('click', (event) => {
        const toggleEl = event.target.closest('.product-accordion__toggle');
        if (!toggleEl) return;

        const contentEl = toggleEl.nextElementSibling;
        if (!contentEl || !contentEl.classList.contains('product-accordion__content')) {
          return;
        }

        const isActive = toggleEl.classList.contains('active');
        if (!isActive) {
          if (typeof window.slideDown === 'function') {
            window.slideDown(toggleEl, contentEl, 300);
          } else if (typeof slideDown === 'function') {
            slideDown(toggleEl, contentEl, 300);
          } else {
            toggleEl.classList.add('active');
            contentEl.classList.add('active');
          }
          toggleEl.setAttribute('aria-expanded', 'true');
        } else {
          if (typeof window.slideUp === 'function') {
            window.slideUp(toggleEl, contentEl, 300);
          } else if (typeof slideUp === 'function') {
            slideUp(toggleEl, contentEl, 300);
          } else {
            toggleEl.classList.remove('active');
            contentEl.classList.remove('active');
          }
          toggleEl.setAttribute('aria-expanded', 'false');
        }
      });
    });
  };

  const initProductFaqsAccordion = () => {
    document.querySelectorAll('.product-faqs-section').forEach(bindFaqsRoot);
    document.querySelectorAll('.product-faqs').forEach((root) => {
      if (!root.closest('.product-faqs-section')) {
        bindFaqsRoot(root);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductFaqsAccordion);
  } else {
    initProductFaqsAccordion();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (
      event.target.querySelector('.product-faqs-section') ||
      event.target.querySelector('.product-faqs')
    ) {
      initProductFaqsAccordion();
    }
  });
})();
